import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../layout/Container'
import { Card } from '../ui/Card'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'
import type { TechCategory } from '../../types'

export function TechStack() {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  const categories: TechCategory[] = t('techStack.categories', { returnObjects: true }) as TechCategory[]

  return (
    <section id="stack" className="bg-surface py-24">
      <Container>
        <div className="mb-16 text-center">
          <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
            {t('techStack.label')}
          </span>
          <h2 className="mt-4 text-3xl font-semibold text-text-primary md:text-4xl">
            {t('techStack.title')}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-text-secondary">
            {t('techStack.description')}
          </p>
        </div>

        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
          transition={{ duration: 0.6 }}
          className="grid gap-6 md:grid-cols-2 lg:grid-cols-3"
        >
          {categories.map((category) => (
            <Card key={category.name} variant="default" hover={false}>
              <h3 className="text-sm font-medium uppercase tracking-wider text-text-muted">
                {category.name}
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {category.items.map((item) => (
                  <span
                    key={item}
                    className="rounded-lg border border-border-subtle bg-surface-elevated px-3 py-2 text-sm font-medium text-text-primary"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </Card>
          ))}
        </motion.div>
      </Container>
    </section>
  )
}
